<template>
	<div>
		<h5>AlarmProcessing</h5>
	</div>
</template>

<script>
	export default {
		name: "AlarmProcessing",
	};
</script>

<style scoped></style>
